import { render } from "./priceRange.vue?vue&type=template&id=d981aa96&scoped=true"
import script from "./priceRange.vue?vue&type=script&lang=js"
export * from "./priceRange.vue?vue&type=script&lang=js"

import "./priceRange.vue?vue&type=style&index=0&id=d981aa96&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d981aa96"]])

export default __exports__